module.exports = __webpack_public_path__ + "img/purple.17188a4a.jpg";